import { sendEvent } from '../../scripts/global/utils/sendEvent'

export default (template) => ({
  mainContainer: null,
  mainMenu: null,
  openMainMenuEnter: false,
  header: null,
  body: null,
  scrolled: false,
  mainContainerWidth: null,
  announcementBar: null,
  secondLevelMenuIsOpen: false,
  lastScrollTop: 0,
  pageTemplate: null,
  navigationMedia: null,
  thirdLevelMenu: false,
  stickyAddToCart: null,
  isSpecialClick(event) {
    return !!(event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1));
  },
  init() {
    this.navigationMedia = document.querySelector(".navigation-media")
    this.mainContainer = document.querySelector("main")
    this.pageTemplate = this.mainContainer.getAttribute("data-template")
    this.overlapCollectionBanner = Boolean(this.mainContainer.getAttribute("data-disable-overlap-collection-banner")) || false;
    this.body = document.body
    this.mainContainer = document.querySelector("main")
    this.mainMenu = document.querySelector(".main-menu")
    this.header = document.querySelector(".header-wrapper")
    this.announcementBar = document.querySelector(".announcement-bar__wrapper")
    this.stickyAddToCart = document.querySelector(".sticky-add-to-cart__container")

    if (this.navigationMedia){
      this.navigationMedia.classList.remove("hide-media")
    }

    if (window.scrollY > 0) {
      this.header.classList.add(template.includes("index") || template.includes("sets") ? "scrolled" : "scrolled-other")
      this.body.classList.add(template.includes("index") || template.includes("sets") ? "scrolled" : "scrolled-other")
      this.scrolled = true
    } else {
      this.header.classList.remove(template.includes("index") || template.includes("sets") ? "scrolled" : "scrolled-other")
      this.body.classList.remove(template.includes("index") || template.includes("sets") ? "scrolled" : "scrolled-other")
      this.scrolled = false
    }

    this.setMainContainerPaddingTop()

    window.addEventListener("resize", ()=>{
      this.setMainContainerPaddingTop()
      this.calculateHeaderWidth()
    })

    window.addEventListener("scroll", (event) => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      const scrollDisabled =
        document.body.style.overflow === "hidden" ||
        getComputedStyle(document.body).overflow === "hidden" ||
        getComputedStyle(document.documentElement).overflow === "hidden";

      if (scrollDisabled) return;

      if (scrollTop >= 0) {
        if (scrollTop > this.lastScrollTop) {
          this.header.classList.remove("scrolled-up");
          this.header.classList.add("scrolled-down");
        } else {
          this.header.classList.remove("scrolled-down");
          this.header.classList.add("scrolled-up");
        }
        this.lastScrollTop = scrollTop;
      }

      const scrolledClass = template.includes("index") || template.includes("sets") ? "scrolled" : "scrolled-other";

      if (scrollTop > 32) {
        this.header.classList.add(scrolledClass);
        this.body.classList.add(scrolledClass);
        this.scrolled = true;
      } else {
        this.header.classList.remove(scrolledClass);
        this.body.classList.remove(scrolledClass);
        this.scrolled = false;
      }
    });

    window.addEventListener("mobile-menu:force-close", () => {
      this.closeMobileMenu()
    })
  },
  setMainContainerPaddingTop(){

    this.$nextTick(()=> {
      if ((this.pageTemplate !== "index" && this.pageTemplate !== "product") && (this.pageTemplate !== "collection" && !this.overlapCollectionBanner)){
        this.mainContainer.style.paddingTop = this.header.offsetHeight + 'px'
      }
    })

    setTimeout(() => {
      document.documentElement.style.setProperty('--header-height',
        `${this.header?.offsetHeight || 0}px`);
    })


  },
  toggleMainMenu(event){
    if (!this.$store.globalState.mainMenuIsOpen){
      this.openMainMenu(event)
    }else{
      this.closeMainMenu()
    }
  },
  openMainMenu(event) {
    if (this.isSpecialClick(event)) {
      return
    }
    event.preventDefault()
    event.stopPropagation()
    document.querySelector("body").classList.add("modal__open")
    document.querySelector("html").classList.add("modal__open")

    if (this.navigationMedia){
      this.navigationMedia.classList.remove("hide-media")
    }
    this.$store.globalState.mainMenuIsOpen = !this.$store.globalState.mainMenuIsOpen
    this.hideSecondLevelMenu()
    this.calculateHeaderWidth()
    sendEvent('Navigation - Nav Open')
  },
  closeMainMenu() {
    document.querySelector("body").classList.remove("modal__open")
    document.querySelector("html").classList.remove("modal__open")
    this.$store.globalState.mainMenuIsOpen = false
    this.hideSecondLevelMenu()
    this.calculateHeaderWidth()
    sendEvent('Navigation - Nav Close')
  },
  makeSecondeLevelItemsVisible(container){
    const items = container?.querySelectorAll(".mega-menu__item")
    if (items){
      items.forEach((item, index) => {
        setTimeout(()=>{
          item.classList.add("visible")
        }, 20 * index)
      })
    }
  },
  hideSecondeLevelItems(container){
    const items = document.querySelectorAll(".mega-menu__item")
    if (items){
      items.forEach((item, index) => {
        item.classList.remove("visible")
      })
    }
  },
  showSecondLevelMenu(event){
    if (this.isSpecialClick(event)) {
      return
    }
    event.preventDefault()
    event.stopPropagation()
    const megaMenuContent = event.currentTarget.previousElementSibling
    let isOpen = megaMenuContent.classList.contains("content-open")
    this.hideSecondLevelMenu()
    this.hideThirdLevelMenu()
    this.makeSecondeLevelItemsVisible(megaMenuContent)

    if (!isOpen){
      event.currentTarget.classList.add("active")
      megaMenuContent.classList.add("content-open")
      if (this.navigationMedia){
        this.navigationMedia.classList.add("hide-media")
      }
    }else{
      this.hideSecondLevelMenu()
      this.hideThirdLevelMenu()
    }

  },
  hideSecondLevelMenu(){
    const navigationItems = document.querySelectorAll(".navigation-item__link")
    const megaMenuContentWrappers = document.querySelectorAll(".megamenu-content")
    navigationItems.forEach(item => {
      item.classList.remove("active")
    })

    megaMenuContentWrappers.forEach(item => {
      item.classList.remove("content-open")
    })
    this.hideSecondeLevelItems()
  },
  showThirdLevelMenu(event){
    if (this.isSpecialClick(event)) {
      return
    }
    event.preventDefault()
    event.stopPropagation()

    this.hideThirdLevelMenu()
    const container = event.currentTarget
    const sliderContainer = container.querySelector(".artists-slider-container")

    container.classList.add("active")

    if (sliderContainer){
      sliderContainer.classList.add("show")
    }

    window.setTimeout(()=>{
      this.thirdLevelMenu = true
    }, 0)
  },
  hideThirdLevelMenu(){
    this.thirdLevelMenu = false
    const sliderAllContainers = document.querySelectorAll(".artists-slider-container")
    const allLinks = document.querySelectorAll(".artists-slider__wrapper")

    allLinks.forEach(item =>{
      item.classList.remove("active")
    })
    if (sliderAllContainers){
      sliderAllContainers.forEach(item => {
        item.classList.remove("show")
      })
    }
  },
  calculateHeaderWidth() {
    this.mainContainerWidth = this.mainContainer
    if (this.announcementBar) {
      this.announcementBar.style.width =
        this.mainContainerWidth.offsetWidth + "px"
    }

    this.header.style.width = this.mainContainerWidth.offsetWidth + "px"
    window.removeEventListener("resize", () => {
      this.mainContainerWidth = this.mainContainer
      if (this.announcementBar) {
        this.announcementBar.style.width =
          this.mainContainerWidth.offsetWidth + "px"
      }
      if (this.header){
        this.header.style.width = this.mainContainerWidth.offsetWidth + "px"
      }
    })
  },
  openMobileMenu() {
    document.querySelector("body").classList.add("modal__open")
    document.querySelector("html").classList.add("modal__open")
    this.$store.globalState.mobileMenuIsOpen = true
    this.body.classList.add("mobile-menu__open")
    sendEvent('Navigation - Nav Open')
  },
  closeMobileMenu() {
    document.querySelector("body").classList.remove("modal__open")
    document.querySelector("html").classList.remove("modal__open")
    this.$store.globalState.mobileMenuIsOpen = false
    this.body.classList.remove("mobile-menu__open")
    const allSecondLevelContents = document.querySelectorAll(".second-level__content")
    allSecondLevelContents.forEach((item) => {
      item.classList.remove("open")
    })
    const allThirdLevelContents = document.querySelectorAll(
      ".third-level__content"
    )

    allThirdLevelContents.forEach(item => {
      item.classList.remove("open")
    })
    sendEvent('Navigation - Nav Close')
  },

  hackCloseBoost() {
    setTimeout(() => {

    const body = document.body;
    const hasBoostClasses =
      body.classList.contains('boost-sd__search-widget-init-enabled') &&
      body.classList.contains('boost-sd__search-opening') &&
      body.classList.contains('boost-sd__g-no-scroll');

    if (hasBoostClasses && body.classList.contains('custom-boost-opened')) {
      document.querySelectorAll('[data-group="close-search-form"]').forEach(btn => btn.click());
      body.classList.remove('custom-boost-opened');
    } else if (hasBoostClasses) {
      body.classList.add('custom-boost-opened');
    } else {
      body.classList.remove('custom-boost-opened');
    }

      document.querySelectorAll('[data-group="close-search-form"]').forEach(btn => {
        btn.addEventListener('click', () => {
          body.classList.remove('custom-boost-opened');
        }, { once: true });
      });

    },100)
  },
  openSecondLevelMenu(event) {
    const allSecondLevelContents = document.querySelectorAll(
      ".second-level__content"
    )
    allSecondLevelContents.forEach((item) => {
      item.classList.remove("open")
    })
    const secondLevelContent = event.currentTarget.nextElementSibling
    if (secondLevelContent){
      secondLevelContent.classList.add("open")
      this.secondLevelMenuIsOpen = true
    }
  },
  closeSecondLevelMenu(event) {

    const secondLevelContent = event.currentTarget.closest(
      ".second-level__content"
    )
    secondLevelContent.classList.remove("open")
    this.closeThirdLevelContent(event)
  },
  openThirdLevelContent(event) {
    const thirdLevelContent = event.currentTarget.nextElementSibling
    thirdLevelContent.classList.add("open")
  },
  closeThirdLevelContent(event) {
    const allThirdLevelContents = document.querySelectorAll(".third-level__content")

    allThirdLevelContents.forEach(item => {
      item.classList.remove("open")
    })

    const thirdLevelContent = event.currentTarget.nextElementSibling
    thirdLevelContent.classList.add("open")
  },
})
